import React from "react";
import { MetricLabel } from "../../MetricCards";
import panelStyles from "../../styles/Panel.module.css";
import analyticsStyles from "../../styles/Analytics.module.css";
import { formatNumber, formatPercent } from "../../utils/formatters";

export function AnalyticsDropoffBlock({ dropOff }) {
  return (
    <div className={analyticsStyles.block}>
      <h3>Анализ потерь</h3>
      <div className={panelStyles.tableWrap}>
        <table className={panelStyles.table}>
          <thead>
            <tr>
              <th>
                <MetricLabel title="Этап" hint="Шаги продуктовой воронки." />
              </th>
              <th>
                <MetricLabel title="Количество" hint="Абсолютное число пользователей на этапе." />
              </th>
              <th>
                <MetricLabel title="% от предыдущего" hint="Текущий / предыдущий этап." />
              </th>
              <th>
                <MetricLabel title="Потеря" hint="Предыдущий этап минус текущий." />
              </th>
            </tr>
          </thead>
          <tbody>
            {(dropOff?.steps || []).map((step, index) => (
              <tr key={step.key || index}>
                <td>{step.label}</td>
                <td>{formatNumber(step.value)}</td>
                <td>{index === 0 ? "—" : formatPercent(step.percentFromPrev)}</td>
                <td>{index === 0 ? "—" : `${formatNumber(step.drop)} (${formatPercent(step.dropRate)})`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {dropOff?.bottleneck ? (
        <div className={panelStyles.note}>
          Основной вклад в потери: {dropOff.bottleneck.label} (-{formatNumber(dropOff.bottleneck.drop)}).
        </div>
      ) : null}
    </div>
  );
}

export default AnalyticsDropoffBlock;
